<template>
  <view-container>
    <v-form v-model="valid">
      <v-card>
        <v-card-text>
          <reference-field
            label="Клиент"
            reference="client"
            v-model="user.clientId"
            :rules="user.$rules.clientId"
          />
          <reference-field
            label="Партнер"
            reference="partner"
            v-model="user.partnerId"
            :rules="user.$rules.partnerId"
          />
          <v-text-field
            label="Имя"
            v-model="user.name"
            :rules="user.$rules.name"
          />
          <v-text-field
            label="Логин"
            v-model="user.login"
            :rules="loginRules"
          />
          <v-text-field
            label="Новый пароль"
            v-model="password"
            type="password"
            :rules="passwordRules"
          />
          <v-switch v-model="user.active" label="активен" />
        </v-card-text>
        <v-card-actions>
          <v-btn @click="save" :disabled="!valid">Сохранить</v-btn>
          <v-btn @click="cancel" text>Отмена</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </view-container>
</template>
<script>
import ds from "@/datastore";
export default {
  name: "UserEdit",
  props: {
    id: String,
    clientId: String,
    partnerId: String
  },
  data() {
    return {
      user: ds.createRecord(
        "user",
        {
          active: true,
          clientId: this.clientId,
          partnerId: this.partnerId
        },
        { noValidate: true }
      ),
      password: "",
      passwordRules: [
        v => v == "" || (v.length >= 8 || "длина пароля не менее 8 символов")
      ],
      valid: false
    };
  },
  computed: {
    loginRules() {
      let rules = [
        v =>
          !v ||
          this.user.isAdmin ||
          /.+@.+\..+/.test(v) ||
          "ошибка в адресе email"
      ];
      this.user.$rules.login && rules.push(...this.user.$rules.login);
      return rules;
    }
  },
  async created() {
    if (this.id) {
      let item = await ds.find("user", this.id);
      this.user = ds.createRecord("user", item.toJSON());
    }
  },
  methods: {
    async save() {
      let user = await this.user.save();
      if (this.password) {
        await this.user.updatePassword(this.password);
      }
      this.$store.commit("notifications/success", "Пользователь сохранен");
      if (!this.id) {
        this.$router.replace({ name: "user-edit", params: { id: user.id } });
      } else {
        this.cancel();
      }
    },
    cancel() {
      this.$destroy();
      this.$router.go(-1);
    }
  }
};
</script>
